import React, { memo, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getUserDetails } from '../../../Store/actions/commonActions';
import { Modal, FloatingLabel, Form } from 'react-bootstrap';

import {
  addRegistration,
  changeSettings,
  editRegistration,
  getAllRegistration,
  otpVerifyForChange,
  updateSpecialityName
} from '../../../Store/actions/profile.action';
import { toast } from 'react-toastify';
import { IoIosArrowDown } from '../../../components/icons';
import { log } from '../../../common/common';
import { useNavigate } from 'react-router-dom';

import isdCodeJson from '../../../common/data/isdcode.json';
const CertificateModal = ({
  show,
  onHide,
  id,
  onVerification = () => {
    console.log('bb');
  },
  userData
}) => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [disabled, setDisabled] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [registrationData, setRegistrationData] = useState(null);
  const [name, setName] = useState('');
  const [regInput, setRegInput] = useState({
    institute_name: '',
    registration_number: '',
    year: ''
  });
  const navigate = useNavigate();

  const [userDetails, setUserDetails] = useState(null);
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [isd, setIsd] = useState('+91');
  const [mobileOtp, setMobileOtp] = useState('');
  const [emailOtp, setEmailOtp] = useState('');
  const [showEmailOtp, setShowEmailOtp] = useState(false);
  const [showMobileOtp, setShowMobileOtp] = useState(false);
  const doDisabled = () => {
    setDisabled(true);
  };
  const doEnabled = () => {
    setDisabled(false);
  };
  const resetRegInput = () => {
    setRegInput({ institute_name: '', registration_number: '', year: '' });
  };

  const handleRegTextInput = (e) => {
    const { name, value } = e.target;
    setRegInput({
      ...regInput,
      [name]: value
    });
  };

  const getRegistrationList = () => {
    dispatch(
      getAllRegistration((res) => {
        console.log('REG', res);
        if (res != 'error') {
          if (res?.length > 0) {
            setIsEdit(true);
            setRegistrationData(res[0]);
            console.log('REGISTRATION', res[0]);
            setRegInput((prevState) => {
              return {
                institute_name: res[0].institute_name,
                year: res[0].year,
                registration_number: res[0].registration_no
              };
            });
          } else {
          }
        }
      })
    );
  };

  const fetchUserDetails = () => {
    dispatch(
      getUserDetails((res) => {
        if (res != 'error') {
          setUserDetails(res?.data);
          setName(`${res?.data?.first_name} ${res?.data?.last_name}`);
          if (res?.data?.email) {
            setEmail(res?.data?.email);
          }
          if (res?.data?.mobile_primary) {
            setMobile(res?.data?.mobile_primary);
          }
        }
      })
    );
  };
  useEffect(() => {
    getRegistrationList();
    return () => {};
  }, []);
  useEffect(() => {
    if (userData) {
      setUserDetails(userData);
      if (userData?.first_name || userData?.last_name || userData?.middle_name) {
        setName(
          `${userData?.first_name ?? ''} ${userData?.middle_name ?? ''} ${
            userData?.last_name ?? ''
          }`
        );
      }
      if (userData?.email) {
        setEmail(userData?.email);
      }
      if (userData?.mobile_primary) {
        setMobile(userData?.mobile_primary);
      }
    } else {
    }
    return () => {
      setUserDetails(null);
      setName('');
      setEmail('');
      setMobile('');
    };
  }, [userData]);
  const submitRegistration = () => {
    if (regInput.institute_name && regInput.registration_number && regInput.year) {
      if (parseInt(regInput.year) >= 1700 && parseInt(regInput.year) <= 2500) {
        if (isEdit) {
          dispatch(
            editRegistration(
              {
                ...regInput,
                registration_id: registrationData.registration_id
              },
              (res) => {
                if (res != 'error') {
                  if (res.status_code == 200) {
                    getRegistrationList();
                    userVerification();
                  } else if (res.status_code == 203) {
                    userVerification();
                  } else {
                    toast.error('Something Went Wrong');
                  }
                } else {
                  log('Something Went Wrong');
                }
              }
            )
          );
        } else {
          dispatch(
            addRegistration(regInput, (res) => {
              if (res != 'error') {
                if (res.status_code == 200) {
                  getRegistrationList();
                  userVerification();
                } else if (res.status_code == 203) {
                  toast.error(res.data.msg);
                } else {
                  toast.error('Something Went Wrong');
                }
              }
            })
          );
        }
      } else {
        toast.error('Please Enter a Valid Year');
      }
    } else {
      toast.error('Please fill the mandatory fields');
    }
  };
  const submitName = (e) => {
    e.preventDefault();
    log('name', name.trim().split(' '));
    if (name) {
      if (name.trim().split(' ').length > 1) {
        let nameArray = name.trim().split(' ');
        doDisabled();
        dispatch(
          updateSpecialityName(
            {
              fname: nameArray[0],
              mname: nameArray?.length > 2 ? nameArray[1] : '',
              lname: `${nameArray?.length > 2 ? nameArray[2] : nameArray[1]}`
            },
            (res) => {
              log('response', res);
              if (res != 'error') {
                dispatch(
                  getUserDetails((res) => {
                    if (res != 'error') {
                      setUserDetails(res?.data);
                      setName(
                        `${res?.data?.first_name} ${res?.data?.middle_name} ${res?.data?.last_name}`
                      );
                    }
                  })
                );
                submitRegistration();
              } else {
                log('Something Went Wrong');
              }
            }
          )
        );
      } else {
        toast.error('Please Enter Your Last Name');
      }
    } else {
      toast.error('Please Enter Your Name');
    }
  };
  const postMobileChange = (callback) => {
    let regexMob = /^\d{10}$/;
    if (!mobile.match(regexMob)) {
      toast.error('Please Enter Mobile No in Correct Format');
    } else {
      let formdata = new FormData();
      formdata.append('type', 'mobile'); //'mobile', 'name', 'email', 'device'
      formdata.append('value', mobile); //for device value will be ""
      formdata.append('isd', isd);
      dispatch(
        changeSettings(formdata, (res) => {
          if (res != 'error') {
            if (res.status_code == 200) {
              log('response', res);
              callback();
            } else if (res?.status_code == 203) {
              toast.error(res?.message);
            }
          }
        })
      );
    }
  };
  const postEmailChange = (callback) => {
    let regexEmail =
      /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
    if (!email.match(regexEmail)) {
      toast.error('Please Enter a Valid Email');
    } else {
      let formdata = new FormData();
      formdata.append('type', 'email'); //'mobile', 'name', 'email', 'device'
      formdata.append('value', email); //for device value will be ""
      dispatch(
        changeSettings(formdata, (res) => {
          if (res != 'error') {
            if (res.status_code == 200) {
              log('response', res);
              callback();
            } else if (res?.status_code == 203) {
              toast.error(res?.message);
            }
          }
        })
      );
    }
  };
  const userVerification = () => {
    doEnabled();
    if (isd && mobile && email) {
      if (mobile == userDetails?.mobile_primary && email == userDetails?.email) {
        onVerification();

        console.log('here ===== >');
      } else if (mobile != userDetails?.mobile_primary && email == userDetails?.email) {
        postMobileChange(() => {
          setStep(2);
          setShowMobileOtp(true);
        });
      } else if (email != userDetails?.email && mobile == userDetails?.mobile_primary) {
        postEmailChange(() => {
          setStep(2);
          setShowEmailOtp(true);
        });
      } else {
        postMobileChange(() => {
          setShowMobileOtp(true);
          postEmailChange(() => {
            setStep(2);
            setShowEmailOtp(true);
          });
        });
      }
    } else {
      toast.error('Please fill the mandatory fields');
    }
  };
  const postMobileOtp = (callback) => {
    let formdata = new FormData();
    formdata.append('type', 'verify');
    formdata.append('mobile_no', mobile);
    formdata.append('isd', isd);
    formdata.append('otp', mobileOtp);
    dispatch(
      otpVerifyForChange(formdata, (res) => {
        if (res != 'error') {
          if (res.status_code == 200) {
            callback();
          } else if (res.status_code == 203) {
            toast.error(res?.message);
          }
        }
      })
    );
  };
  const postEmailOtp = (callback) => {
    if (emailOtp) {
      let formdata = new FormData();
      formdata.append('type', 'emailverify');
      formdata.append('email', email);
      formdata.append('otp', emailOtp);
      dispatch(
        otpVerifyForChange(formdata, (res) => {
          if (res != 'error') {
            if (res.status_code == 200) {
              log('response', res);
              callback();
            } else if (res.status_code == 203) {
              toast.error(res?.message);
            }
          }
        })
      );
    } else {
      toast.error('Please Enter Email OTP');
    }
  };
  const otpVerification = () => {
    if (showEmailOtp && !showMobileOtp) {
      postEmailOtp(() => {
        fetchUserDetails();
        onVerification();
      });
    } else if (!showEmailOtp && showMobileOtp) {
      postMobileOtp(() => {
        fetchUserDetails();
        onVerification();
      });
    } else if (showEmailOtp && showMobileOtp) {
      postMobileOtp(() => {
        postEmailOtp(() => {
          fetchUserDetails();
          onVerification();
        });
      });
    }
  };
  return (
    <Modal className="centerModal" size="md" centered show={show} onHide={onHide}>
      <Modal.Header className="position-relative border-0 p-4 mb-1">
        <Modal.Title className="fs-4 text-black fw-semibold">
          Please verify the following details to create & send the certificate for participation in
          the CME
        </Modal.Title>
      </Modal.Header>
      {step == 1 && (
        <Modal.Body className="p-4" style={{ overflowY: 'auto' }}>
          <form>
            <div className="w-100 centerModalFrm">
              <div className="row mt-n4">
                <FloatingLabel className="mt-4 px-0" controlId="floatingInput" label="Your Name *">
                  <Form.Control
                    className="fs-4"
                    type="text"
                    placeholder="Your Name *"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                  />
                </FloatingLabel>
                <FloatingLabel
                  className="mt-4 px-0"
                  controlId="floatingInput"
                  label="Medical council *"
                >
                  <Form.Control
                    className="fs-4"
                    type="text"
                    placeholder="Medical council"
                    value={regInput.institute_name}
                    name="institute_name"
                    onChange={handleRegTextInput}
                  />
                </FloatingLabel>
                <FloatingLabel
                  className="mt-4 px-0"
                  controlId="floatingInput"
                  label="Medical Reg No. *"
                >
                  <Form.Control
                    className="fs-4"
                    type="text"
                    placeholder="Medical Reg No."
                    value={regInput.registration_number}
                    name="registration_number"
                    onChange={handleRegTextInput}
                  />
                </FloatingLabel>
                <FloatingLabel
                  className="mt-4 px-0"
                  controlId="floatingInput"
                  label="Registration Year *"
                >
                  <Form.Control
                    className="fs-4"
                    type="text"
                    placeholder="Enter Registration Year"
                    value={regInput.year}
                    name="year"
                    onChange={handleRegTextInput}
                  />
                </FloatingLabel>
                <FloatingLabel
                  className="mt-4 px-0"
                  controlId="floatingInput"
                  label="Enter Your Email *"
                >
                  <Form.Control
                    className="fs-4"
                    type="text"
                    placeholder="Enter Your Email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      console.log(email);
                    }}
                  />
                </FloatingLabel>
                <div className="cmnisdCodeParent mt-4 position-relative border border-light rounded pe-0">
                  <div className="cmnisdCodeSelect position-absolute top-0 start-0 z-2 h-100 border-end border-light text-black fs-4 fw-medium bg-transparent">
                    <select
                      className="w-100 h-100 pe-5 ps-3 bg-transparent"
                      onChange={(e) => {
                        setIsd(e.target.value);
                      }}
                      defaultChecked="+91"
                    >
                      {isdCodeJson.map((item, index) => (
                        <option name={item.name} value={item.value}>
                          {item.value}
                        </option>
                      ))}
                    </select>
                    <IoIosArrowDown
                      customClass={'fs-16 position-absolute top-50 translate-middle-y'}
                    />
                  </div>
                  <FloatingLabel controlId="floatingInput" label="Enter Your Mobile No. *">
                    <Form.Control
                      className="fs-4"
                      type="text"
                      placeholder="Enter Your Mobile No."
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                    />
                  </FloatingLabel>
                </div>
                <div className="mt-4 px-0 d-flex flex-wrap centerModalBttns z-3">
                  <button
                    className="col fs-4 btn btn-danger py-3 px-4"
                    type="button"
                    onClick={onHide}
                    aria-label="Cancel"
                  >
                    Cancel
                  </button>
                  <button
                    className="col fs-4 btn btn-primary py-3 px-4"
                    type="button"
                    onClick={submitName}
                    aria-label="Verify"
                    disabled={disabled}
                  >
                    Verify
                  </button>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
      )}

      {step == 2 && (
        <Modal.Body className="p-4">
          <Form>
            <div className="w-100 centerModalFrm">
              <div className="row mt-n4">
                {showMobileOtp && (
                  <FloatingLabel
                    className="mt-4 px-0"
                    controlId="floatingInput"
                    label="Enter Your Mobile OTP *"
                  >
                    <Form.Control
                      className="fs-4"
                      type="text"
                      placeholder="Enter Your Mobile OTP"
                      value={mobileOtp}
                      onChange={(e) => setMobileOtp(e.target.value)}
                    />
                  </FloatingLabel>
                )}
                {showEmailOtp && (
                  <FloatingLabel
                    className="mt-4 px-0"
                    controlId="floatingInput"
                    label="Enter Your Email OTP *"
                  >
                    <Form.Control
                      className="fs-4"
                      type="text"
                      placeholder="Enter Your Email OTP"
                      value={emailOtp}
                      onChange={(e) => setEmailOtp(e.target.value)}
                    />
                  </FloatingLabel>
                )}
                <div className="mt-4 px-0 d-flex flex-wrap centerModalBttns">
                  <button
                    className="col fs-4 btn btn-danger py-3 px-4"
                    type="button"
                    onClick={onHide}
                    aria-label="Cancel"
                  >
                    Cancel
                  </button>
                  <button
                    className="col fs-4 btn btn-primary py-3 px-4"
                    type="button"
                    onClick={otpVerification}
                    aria-label="Verify"
                    disabled={disabled}
                  >
                    Verify{' '}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
      )}
    </Modal>
  );
};

export default CertificateModal;
